<template>
  <div style="width: 100%">
    <nav-header v-if="$route.name=='postDetail' &&!circleInfo.enableCustomNav " />
    <HeadNav v-else :circle-id="post.circleId"></HeadNav>
    <div class="post-detail container">
      <div class="post-detail-wrapper">
        <!-- 左侧帖子内容 -->
        <div class="post-main">
          <!-- 帖子内容卡片 -->
          <el-card class="post-card">
            <h3 style="text-align: center" v-if="post.title">{{post.title}}</h3>
            <!-- 帖子头部 -->
            <div class="post-header">
              <router-link :to="'/profile/'+post.createBy  ">
              <div class="circle-user-info">
                <el-avatar :size="40" :src="post.imUserVo?.headImageThumb"/>
                <div class="user-meta">
                  <span class="nickname">{{post.imUserVo?.nickName}}</span>
                  <span class="time">{{post.createTime}}</span>
                  <span class="">  <i class="el-icon-view"></i>{{post.viewCount}}</span>
                </div>
              </div> </router-link>
              <div class="post-actions" v-if="isOwner || isAdmin">
                <el-dropdown trigger="click" @command="handleCommand">
                  <el-button type="text">
                    <i class="el-icon-more"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit" divided>编辑</el-dropdown-item>
                    <el-dropdown-item command="delete" divided>删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>

            <!-- 帖子内容 -->
            <div class="post-content">
              <div v-if="post.title">
                <Editor
                    v-model="post.content"
                    :defaultConfig="{readOnly :true}"
                />
              </div>
              <pre class="post-text" v-else >{{post.content}}</pre>
              <!-- 图片列表 -->
              <div v-if="post.images" class="image-list" >
                <el-image
                  v-for="(img,index) in JSON.parse(post.images)"
                  :key="index"
                  :src="img"
                  :preview-src-list="JSON.parse(post.images)"
                  fit="cover"
                />
              </div>

              <!-- 附件列表 -->
              <div v-if="post.files" class="file-list">
                <div 
                  v-for="(file,index) in JSON.parse(post.files)"
                  :key="index"
                  class="file-item"
                >
                  <i :class="getFileIcon(file.type)"></i>
                  <span class="file-name">{{file.name}}</span>
                  <span class="file-size">{{formatSize(file.size)}}</span>
                  <div class="file-actions">
                    <el-button 
                      type="text" 
                      icon="el-icon-view"
                      @click="previewFile(file)"
                    />
                    <el-button
                      type="text"
                      icon="el-icon-download"
                      @click="downloadFile(file)"
                    />
                  </div>
                </div>
              </div>
            <!--文件列表-->
              <file-manager :bus-id="post.id" v-if="showFile && post.id " :parent-id="post.circleId" :pre="post.createBy!=userStore.userInfo.id" @noData="()=>{showFile=false}"></file-manager>
            </div>

            <!-- 帖子底部 -->
            <div class="post-footer">
              <div class="post-actions">
                <span @click="toggleLike">
                  <i :class="post.liked ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
                  {{post.likeCount}}
                </span>
              </div>
            </div>
          </el-card>

          <!-- 评论区 -->
          <div class="comments-section">
            <div class="section-header">
              <h3>评论区 <span class="count">({{total}})</span></h3>
            </div>
            <!-- 图片预览 -->
            <div class="image-preview" v-if="commentImages.length">
              <div class="preview-item" v-for="(img, index) in commentImages" :key="index">
                <el-image :src="img" fit="cover"></el-image>
                <div class="delete-btn" @click="deleteCommentImage(index)">
                  <i class="el-icon-close"></i>
                </div>
              </div>
            </div>
            <!-- 评论输入框 -->
            <div class="comment-input" :class="{ 'reply-mode': replyTo }">
              <div class="input-wrapper">
                <div class="reply-info" v-if="replyTo">
                  <span>回复 {{replyTo.userName}}</span>
                  <i class="el-icon-close" @click="cancelReply"></i>
                </div>
                <el-input
                    type="textarea"
                    v-model="commentText"
                    class="comment-textarea"
                    :rows="3"
                    :placeholder="replyTo ? `回复 ${replyTo.userName}...` : '说点什么...'"
                    maxlength="200"
                    show-word-limit
                ></el-input>

                <!-- 图片上传 -->
                <div class="action-bar">
                  <el-upload
                      :action="action"
                      :show-file-list="false"
                      :on-success="onUploadSuccess"
                      :before-upload="beforeUpload"
                      accept="image/*"
                      multiple
                  >
                    <i class="el-icon-picture"></i>
                  </el-upload>
                  <el-button
                      type="primary"
                      size="small"
                      @click="submitComment"
                      :disabled="!commentText.trim() && !commentImages.length"
                  >发送</el-button>
                </div>
              </div>
            </div>
            <!-- 评论列表 -->
            <div class="comments-list"
                 v-infinite-scroll="loadMore"
                 infinite-scroll-disabled="loading"
                 infinite-scroll-distance="10"
                 infinite-scroll-immediate="false"
            >
              <div class="comment-item" v-for="comment in comments" :key="comment.id">
                <div class="comment-main">
                  <div class="comment-header">
                    <div class="comment-user-info">
                      <el-avatar :src="comment.userAvatar" :size="40"></el-avatar>
                      <div class="user-meta">
                        <span class="username">{{comment.userName}}</span>
                        <span class="time">{{comment.createTime}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="comment-content">
                    <div class="text">{{comment.content}}</div>
                    <!-- 评论图片 -->
                    <div class="image-list" v-if="comment.images">
                      <el-image
                          v-for="(img, imgIndex) in formatImages(comment.images)"
                          :key="imgIndex"
                          :src="img"
                          fit="cover"
                          :preview-src-list="formatImages(comment.images)"
                      ></el-image>
                    </div>
                    <!-- 评论操作 -->
                    <div class="comment-actions">
                        <span class="action-btn" @click="handleReply(comment)">
                          <i class="el-icon-chat-dot-round"></i> 回复
                        </span>
                      <span class="action-btn delete"
                            v-if="comment.createBy === userStore.userInfo.id || isOwner"
                            @click="deleteComment(comment.id)">
                        <i class="el-icon-delete"></i> 删除
                      </span>
                    </div>
                  </div>
                </div>

                <!-- 回复列表 -->
                <div class="replies-list" v-if="comment.replies && comment.replies.length">
                  <div class="reply-item" v-for="reply in comment.replies" :key="reply.id">
                    <div class="comment-header">
                      <div class="comment-user-info">
                        <el-avatar :src="reply.userAvatar" :size="32"></el-avatar>
                        <div class="user-meta">
                          <span class="username">{{reply.userName}}</span>
                          <span class="reply-to" v-if="reply.replyToUserName">
                              回复 <span class="reply-name">@{{reply.replyToUserName}}</span>
                            </span>
                          <span class="time">{{reply.createTime}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="reply-content">
                      <div class="text">{{reply.content}}</div>
                      <!-- 回复图片 -->
                      <div class="image-list" v-if="reply.images">
                        <el-image
                            v-for="(img, imgIndex) in formatImages(reply.images)"
                            :key="imgIndex"
                            :src="img"
                            fit="cover"
                            :preview-src-list="formatImages(reply.images)"
                        ></el-image>
                      </div>
                      <!-- 回复操作 -->
                      <div class="reply-actions">
                          <span class="action-btn" @click="handleReply(comment, reply)">
                            <i class="el-icon-chat-dot-round"></i> 回复
                          </span>
                        <span class="action-btn delete"
                              v-if="reply.createBy === userStore.userInfo.id || isOwner"
                              @click="deleteComment(reply.id)">
                            <i class="el-icon-delete"></i> 删除
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 加载状态 -->
              <div class="load-more" v-if="loading">
              </div>

              <!-- 空状态 -->
              <div class="empty-state" v-if="comments.length === 0 && !loading">
                暂无评论，快来抢沙发吧~
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧圈子信息 -->
        <div class="circle-sidebar">
          <el-card class="circle-info-card">
            <!-- 圈子基本信息 -->
            <div class="circle-header">
              <el-avatar :size="60" :src="circleInfo.avatar" @click="goCircle"/>
              <div class="circle-meta">
                <h3 class="circle-name" @click="goCircle">{{circleInfo.name}}</h3>
                <div class="circle-stats">
                  <span><i class="el-icon-user"></i>{{circleInfo.memberCount}}成员</span>
                  <span><i class="el-icon-document"></i>{{circleInfo.postCount}}帖子</span>
                </div>
              </div>
            </div>
            
            <!-- 圈子简介 -->
            <div class="circle-desc">
              <div class="desc-title">圈子简介</div>
              <div class="desc-content">{{circleInfo.description || '暂无简介'}}</div>
              <div class="desc-item" v-if="circleInfo.joinType === 1">
                <span class="label">加入费用:</span>
                <span class="value">¥{{circleInfo.price}}</span>
              </div>
              <div class="desc-item">
                <span class="label">创建时间:</span>
                <span class="value">{{circleInfo.createTime}}</span>
              </div>
            </div>
          </el-card>
          <qrcode :url="'/h5/#/pages/community/post-detail?id='+$route.params.id"></qrcode>
          <!-- 热门帖子 -->
          <el-card class="hot-posts-card" v-if="hotPosts.length>0">
            <div slot="header" class="card-header">
              <span>热门帖子</span>
            </div>
            <div class="hot-post-list">
              <div v-for="post in hotPosts" 
                   :key="post.id" 
                   class="hot-post-item"
                   @click="goPost(post.id)">
                <div class="post-title">{{post.title || post.content}}</div>
                <div class="post-meta">
                  <span><i class="el-icon-chat-dot-round"></i>{{post.commentCount}}</span>
                  <span><i class="el-icon-star-off"></i>{{post.likeCount}}</span>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <subscribe ref="subscribe"></subscribe>
  </div>
</template>

<script>
import NavHeader from "@/components/layout/NavHeader.vue";
import PostPublish from "@/view/community/post-publish.vue";
import HeadNav from "@/components/common/HeadNav.vue";
import Subscribe from "@/components/common/subscribe.vue";
import {Editor} from "@wangeditor/editor-for-vue";
import FileManager from "@/components/FileManager/index.vue";
import Qrcode from "@/components/Qrcode/index.vue";
const isMobileDevice=() =>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检查用户代理字符串
  return /android|iPhone|iPad|iPod|windows phone|blackberry|iemobile|opera mini/i.test(userAgent);
}
export default {
  name: 'PostDetail',
  components: {Qrcode, FileManager, Editor, Subscribe, HeadNav, PostPublish, NavHeader},

  data() {
    return {
      showFile:true,
      pushDialog:false,
      post: {},
      isOwner: false,
      isAdmin: false,
      comments: [],
      page: 1,
      total: 0,
      commentContent: '',
      replyTo: null,
      commentText: '',
      commentImages: [],
      action: process.env["VUE_APP_BASE_API2"]+'/system/image/upload',
      loading: false,
      maxImages: 9,
      circleInfo: {
        avatar: '',
        name: '',
        description: '',
        memberCount: 0,
        postCount: 0,
        joinType: 0
      },
      isMember: false,
      joining: false,
      hotPosts: []
    }
  },

  computed: {
    userInfo() {
      return this.userStore.userInfo
    }
  },

  created() {
    if(isMobileDevice()) location.href= process.env["VUE_APP_SHARE_BASE"]+"/h5/#/pages/community/post-detail?id="+this.$route.params.id;
    this.loadPost()
    this.loadComments()
  },
  watch: {
    '$route' (to, from) {
      console.log('路由变化了！');
      console.log('从', from, '到', to);
      this.loadPost()
      this.loadComments()
    }
  },
  methods: {
    // 格式化图片数组
    formatImages(images) {
      if (!images) return []
      return typeof images === 'string' ? images.split(',') : images
    },
    // 加载帖子详情
    async loadPost() {
      try {
        this.pushDialog=false;
        const res = await this.$http2({
          url: `/klgeek/postDeatil/${this.$route.params.id}`,
          method: 'GET'
        })
        this.post = res.data
        this.loadCircleInfo()
        this.loadHotPosts()
        if(!(sessionStorage.getItem("accessToken") ||localStorage.getItem("accessToken"))) return
        this.userStore.loadUser()
        this.isOwner = this.post.createBy === this.userStore.userInfo.id
        const res2 = await this.$http2({
		    url: `/klgeek/circleMember/role/check/${this.post.circleId}`,
		    method: 'GET'
		  })

		  this.isAdmin = res2.data >= 1 // 管理员或圈主
      } catch(e) {
        console.error(e)
      }
    },

    // 加载评论列表
    async loadComments(refresh=false) {
      if (refresh===true) {
        this.page = 1
        this.comments = []
      }
      if (this.loading) return
      
      try {
        this.loading = true
        const res = await this.$http2({
          url: '/klgeek/comment/list/'+this.$route.params.id,
          params: {
            busType:"circle",
            pageNum: this.page,
            pageSize: 10
          }
        })
        if (this.page === 1) {
          this.comments = res.rows
        } else {
          this.comments = [...this.comments, ...res.rows]
        }
        this.total = res.total
      } catch(e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    // 处理回复
    handleReply(comment, reply = null) {
      this.replyTo = {
        commentId: reply ? comment.id : comment.id,
        userId: reply ? reply.createBy : comment.createBy,
        userName: reply ? reply.userName : comment.userName,
        replyToUserName: reply?.userName
      }

      // 聚焦到评论输入框
      this.$nextTick(() => {
        const textarea = this.$el.querySelector('.el-textarea__inner')
        console.log(textarea)
        if (textarea) {
          textarea.focus()
        }
      })
    },

    // 取消回复
    cancelReply() {
      this.replyTo = null
      this.commentText = ''
    },
    // 提交评论
    async submitComment() {
      if(!this.commentText.trim() && !this.commentImages.length) return
      
      try {
        const data = {
          creationId: this.$route.params.id,
          content: this.commentText,
          images: this.commentImages.join(","),
          userName: this.userStore.userInfo.nickName,
          userAvatar: this.userStore.userInfo.headImageThumb,
          createBy:this.post.createBy,
          busType:"circle",
          params:{type:'circle'}

        }
        if (this.replyTo) {
          data.parentId = this.replyTo.commentId
          data.replyUserId = this.replyTo.userId
          data.replyToUserName = this.replyTo.replyToUserName
        }
        await this.$http2({
          url: '/klgeek/comment',
          method: 'POST',
          data
        })
        this.$message.success('评论成功')
        this.commentText = ''
        this.commentImages = []
        this.replyTo = null
        this.page = 1
        this.loadComments()
        if(!this.userStore.userInfo.openid){
          this.$refs.subscribe.showDialog();
        }
      } catch(e) {
        console.error(e)
      }
    },

    // 删除评论
    async deleteComment(commentId) {
      this.$confirm('确定要删除该评论吗?', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          await this.$http2({
            url: `/klgeek/comment/${commentId}`,
            method: 'DELETE'
          })
          this.$message.success('删除成功')
          await this.loadComments(true)
        } catch(e) {
          console.error(e)
        }
      })
    },

    // 点赞/取消点赞
    async toggleLike() {
      try {
        if(this.post.liked) {
          await this.$http2({
            url: `/klgeek/postLike`,
            data:{
              postId:this.post.id
            },
            method: 'PUT'
          })
          this.post.liked = false
          this.post.likeCount--
        } else {
          await this.$http2({
            url: `/klgeek/postLike`,
            data:{
              postId:this.post.id
            },
            method: 'POST'
          })
          this.post.liked = true
          this.post.likeCount++
        }
      } catch(e) {
        console.error(e)
      }
    },

    // 处理更多操作
    async handleCommand(command) {
      switch(command) {
        case 'essence':
          await this.setEssence()
          break
        case 'cancelEssence':
          await this.cancelEssence()
          break
        case 'top':
          await this.setTop()
          break
        case 'cancelTop':
          await this.cancelTop()
          break
        case 'delete':
          await this.deletePost()
          break
        case 'edit':
          this.$router.push(`/pushPost?id=${this.post.id}`)
          break
      }
    },

    // 设为精华
    async setEssence() {
      try {
        await this.$http2({
          url: `/klgeek/post/essence/${this.post.id}`,
          method: 'PUT'
        })
        this.$message.success('已设为精华')
        this.loadPost()
      } catch(e) {
        console.error(e)
      }
    },

    // 取消精华
    async cancelEssence() {
      try {
        await this.$http2({
          url: `/klgeek/post/essence/${this.post.id}`,
          method: 'DELETE'
        })
        this.$message.success('已取消精华')
        this.loadPost()
      } catch(e) {
        console.error(e)
      }
    },

    // 设置置顶
    async setTop() {
      try {
        await this.$http2({
          url: `/klgeek/post/top/${this.post.id}`,
          method: 'PUT'
        })
        this.$message.success('已置顶')
        this.loadPost()
      } catch(e) {
        console.error(e)
      }
    },

    // 取消置顶
    async cancelTop() {
      try {
        await this.$http2({
          url: `/klgeek/post/top/${this.post.id}`,
          method: 'DELETE'
        })
        this.$message.success('已取消置顶')
        this.loadPost()
      } catch(e) {
        console.error(e)
      }
    },

    // 删除帖子
    async deletePost() {
      this.$confirm('确定要删除该帖子吗?', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          await this.$http2({
            url: `/klgeek/post/${this.post.id}`,
            method: 'DELETE'
          })
          this.$message.success('删除成功')
          this.$router.back()
        } catch(e) {
          console.error(e)
        }
      })
    },

    // 分页切换
    handlePageChange(val) {
      this.page = val
      this.loadComments()
    },

    // 获取文件图标
    getFileIcon(type) {
      const icons = {
        'doc,docx': 'el-icon-document',
        'xls,xlsx': 'el-icon-tickets',
        'ppt,pptx': 'el-icon-picture',
        'pdf': 'el-icon-document',
        'txt': 'el-icon-document-remove',
        'zip,rar,7z': 'el-icon-folder',
        'default': 'el-icon-document'
      }

      for(let key in icons) {
        if(key.split(',').includes(type)) {
          return icons[key]
        }
      }
      return icons.default
    },

    // 格式化文件大小
    formatSize(size) {
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      while(size > 1024 && index < units.length - 1) {
        size = size / 1024
        index++
      }
      return size.toFixed(2) + units[index]
    },

    // 预览文件
    previewFile(file) {
      let linkUrl =null;
      if(file.type=='ppt'||file.type=='pptx'||file.type=='doc'||file.type=='docx'||file.type=='xls'||file.type=='pdf'||file.type=='xlsx')
      {
        linkUrl = "https://pan.imgbed.link/file/preview/"+file.id;
      }else{
        const encoder = new TextEncoder();
        const data = "https://pan.imgbed.link/file/"+file.id+"?fullfilename="+file.name;
        const encodedData = btoa(String.fromCharCode(...new Uint8Array(encoder.encode(data))));
        linkUrl ="https://pan.imgbed.link/kkpreview/onlinePreview?url="+encodeURIComponent(encodedData)
      }
      window.open(linkUrl)
    },

    // 下载文件
    async  downloadFile(file) {
      try {
        // 发起请求获取文件blob
        const loading = this.$loading({
          lock: true,
          text: '下载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        const response = await fetch(file.url, {
          method: 'GET',
        })
        const blob = await response.blob()
        loading.close()
        // 创建blob链接
        const blobUrl = window.URL.createObjectURL(blob)
        // 创建下载链接
        const downloadLink = document.createElement('a')
        downloadLink.href = blobUrl
        downloadLink.download = file.name // 设置下载文件名

        // 添加到body并触发点击
        document.body.appendChild(downloadLink)
        downloadLink.click()

        // 清理
        document.body.removeChild(downloadLink)
        window.URL.revokeObjectURL(blobUrl)
      } catch(e) {
        console.error('Download file error:', e)
        this.$message.error('下载失败')
      }
    },

    // 显示回复输入框
    showReplyInput(comment, reply = null) {
      this.$set(comment, 'showReplyInput', true)
      this.$set(comment, 'replyContent', '')
      this.$set(comment, 'replyTo', reply)
    },

    // 提交回复
    async submitReply(comment) {
      if (!comment.replyContent.trim()) return

      try {
        await this.$http2({
          url: '/klgeek/comment',
          method: 'POST',
          data: {
            postId: this.post.id,
            content: comment.replyContent,
            parentId: comment.id,
            replyUserId: comment.replyTo?.imUserVo.id
          }
        })
        
        this.$message.success('回复成功')
        comment.showReplyInput = false
        this.loadComments() // 重新加载评论列表
      } catch(e) {
        console.error(e)
      }
    },


    // 上传图片前检查
    beforeUpload(file) {
      if(this.commentImages.length >= this.maxImages) {
        this.$message.warning(`最多只能上传${this.maxImages}张图片`)
        return false
      }
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      return true
    },

    // 图片上传成功
    onUploadSuccess(response, file) {
      if (response.code === 200) {
        // 检查图片数量限制
        if (this.commentImages.length >= this.maxImages) {
          this.$message.warning(`最多只能上传${this.maxImages}张图片`)
          return
        }

        // 添加图片URL到数组
        this.commentImages.push(response.data.thumbUrl)
      } else {
        this.$message.error('图片上传失败')
      }
    },

    // 删除预览图片
    deleteCommentImage(index) {
      this.commentImages.splice(index, 1)
    },

    // 加载更多
    loadMore() {
      if (this.loading) return
      if (this.comments.length >= this.total) return
      this.page++
      this.loadComments()
    },

    // 加载圈子信息
    async loadCircleInfo() {
      try {
        const res = await this.$http2({
          url: `/klgeek/circle/${this.post.circleId}`,
          method: 'GET'
        })
        this.circleInfo = res.data
        // this.isMember = res.data.isMember
      } catch(e) {
        console.error(e)
      }
    },

    // 加入圈子
    async joinCircle() {
      this.joining = true
      try {
        await this.$http2({
          url: `/klgeek/circleMember/join/${this.post.circleId}`,
          method: 'POST'
        })
        this.$message.success('加入成功')
        this.isMember = true
        this.loadCircleInfo()
      } catch(e) {
        console.error(e)
      }
      this.joining = false
    },

    // 加载热门帖子
    async loadHotPosts() {
      try {
        const res = await this.$http2({
          url: '/klgeek/post/hot/list',
          method: 'GET',
          params: {
            circleId: this.post.circleId
          }
        })
        this.hotPosts = res.data
      } catch(e) {
        console.error(e)
      }
    },

    // 跳转到圈子页面
    goCircle() {
      this.$router.push({ name: 'postList', params: { id: this.post.circleId } })
    },

    // 跳转到帖子页面
    goPost(postId) {
      this.$router.push({ name: 'postDetail', params: { id: postId } })
    }
  }
}
</script>

<style lang="scss" scoped>
.post-detail {
  padding: 10px;
  margin: 0 auto;
  max-width: 1200px;  // 添加最大宽度限制
  
  .post-detail-wrapper {
    display: flex;
    gap: 20px;
    position: relative;
  }

  .post-main {
    flex: 1;
    min-width: 0;
  }
  
  .post-card {
    margin-bottom: 20px;

    .post-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
      
      .circle-user-info {
        display: flex;
        align-items: center;
        
        .user-meta {
          margin-left: 10px;
          
          .nickname {
            display: block;
            font-weight: bold;
          }
          
          .time {
            font-size: 12px;
            color: #999;
          }
        }
      }
    }

    .post-content {
      .post-text {
        margin-bottom: 15px;
        line-height: 1.6;
        font-size: 1rem;
      }
      
      .image-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
        margin-bottom: 15px;
        
        .el-image {
          width: 100%;
          height: 200px;
          border-radius: 4px;
        }
      }
      
      .file-list {
        .file-item {
          display: flex;
          align-items: center;
          padding: 10px;
          background: #f5f5f5;
          border-radius: 4px;
          margin-bottom: 10px;
          
          i {
            font-size: 24px;
            margin-right: 10px;
          }
          
          .file-name {
            flex: 1;
            margin-right: 10px;
          }
          
          .file-size {
            color: #999;
            margin-right: 10px;
          }
        }
      }
    }

    .post-footer {
      display: flex;
      justify-content: flex-end;
      padding-top: 15px;
      border-top: 1px solid #eee;
      
      .post-actions {
        span {
          margin-left: 20px;
          color: #666;
          cursor: pointer;
          
          i {
            margin-right: 5px;
          }
          
          &:hover {
            color: #409EFF;
          }
        }
      }
    }
  }

  .comments-section {
    margin-top: 20px;

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;

      h3 {
        font-size: 16px;
        margin: 0;
        color: #333;
      }

      .view-all {
        font-size: 13px;
        color: #666;
        text-decoration: none;

        &:hover {
          color: #409EFF;
        }
      }
    }

    .comments-list {
    }

    .image-preview {
      .preview-item {
        position: relative;
        display: inline-block;
        margin: 5px;

        .el-image {
          width: 100px;
          height: 100px;
          border-radius: 4px;
        }

        .delete-btn {
          position: absolute;
          top: 5px;
          right: 5px;
          cursor: pointer;
          color: #999;

          &:hover {
            color: #409EFF;
          }
        }
      }
    }

    .comment-input {
      margin-top: 20px;
      padding: 10px;
      background: #f5f5f5;
      border-radius: 4px;

      &.reply-mode {
        padding: 10px;
      }

      .input-wrapper {
        display: flex;
        align-items: center;

        .reply-info {
          margin-right: 10px;
          color: #999;

          i {
            cursor: pointer;
            margin-left: 5px;

            &:hover {
              color: #409EFF;
            }
          }
        }

        .comment-textarea {
          flex: 1;
        }

        .action-bar {
          margin-left: 10px;

          .el-upload {
            margin-right: 10px;
          }
        }
      }
    }
  }

  .danger {
    color: #F56C6C;
    
    &:hover {
      color: #f78989;
    }
  }

  .pagination {
    margin-top: 20px;
    text-align: center;
  }
  .comment-item {
    margin-bottom: 24px;

    .comment-main {
      margin-bottom: 20px;

      .comment-header {
        margin-bottom: 12px;

        .comment-user-info {
          display: flex;
          align-items: center;
          gap: 12px;

          .user-meta {
            display: flex;
            align-items: center;
            gap: 12px;

            .username {
              font-size: 14px;
              font-weight: 500;
              color: #333;
              line-height: 1;
            }

            .time {
              font-size: 12px;
              color: #999;
              line-height: 1;
            }
          }
        }
      }

      .comment-content {
        padding-left: 52px; // 头像宽度(40px) + 间距(12px)

        .text {
          font-size: 14px;
          color: #333;
          line-height: 1.6;
        }
      }
    }

    // 回复列表样式
    .replies-list {
      margin-top: 16px;
      margin-left: 52px; // 与主评论内容对齐
      padding-left: 16px; // 添加左侧内边距
      border-left: 2px solid #f0f0f0; // 添加左侧边框线

      .reply-item {
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        .comment-header {
          margin-bottom: 8px;

          .comment-user-info {
            display: flex;
            align-items: center;
            gap: 8px;

            .user-meta {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              gap: 8px;

              .username {
                font-size: 14px;
                font-weight: 500;
                color: #333;
              }

              .reply-to {
                font-size: 14px;
                color: #666;

                .reply-name {
                  color: #409EFF;
                }
              }

              .time {
                font-size: 12px;
                color: #999;
              }
            }
          }
        }

        .reply-content {
          padding-left: 40px; // 头像宽度(32px) + 间距(8px)

          .text {
            font-size: 14px;
            color: #333;
            line-height: 1.6;
          }
        }
      }
    }
  }

  .comment-actions,
  .reply-actions {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 16px;

    .action-btn {
      display: inline-flex;
      align-items: center;
      font-size: 13px;
      color: #8c8c8c;
      cursor: pointer;
      padding: 4px 0;

      i {
        margin-right: 4px;
        font-size: 14px;
      }

      &:hover {
        color: #409EFF;
      }

      &.delete {
        &:hover {
          color: #F56C6C;
        }
      }
    }
  }

  // 回复列表中的操作按钮稍微小一点
  .reply-actions {
    .action-btn {
      font-size: 12px;

      i {
        font-size: 13px;
      }
    }
  }

  .comment-input {
    background: #fff;
    padding: 20px;
    border-top: 1px solid #f5f5f5;

    &.reply-mode {
      padding-top: 10px;
    }

    .input-wrapper {
      .reply-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 0;
        color: #666;
        font-size: 13px;

        i {
          cursor: pointer;
          &:hover {
            color: #409EFF;
          }
        }
      }
    }
  }

  // 评论图片列表样式
  .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;

    .el-image {
      width: 100px;
      height: 100px;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        opacity: 0.9;
      }
    }
  }

  // 回复列表中的图片稍微小一点
  .replies-list {
    .image-list {
      .el-image {
        width: 80px;
        height: 80px;
      }
    }
  }

  .circle-sidebar {
    width: 300px;
    flex-shrink: 0;  // 防止侧边栏被压缩
    
    .circle-info-card {
      margin-bottom: 20px;
      
      .circle-header {
        display: flex;
        gap: 16px;
        margin-bottom: 16px;
        
        .circle-meta {
          flex: 1;
          min-width: 0;
          
          .circle-name {
            font-size: 18px;
            margin: 0 0 8px;
            cursor: pointer;
            
            &:hover {
              color: #409EFF;
            }
          }
          
          .circle-stats {
            display: flex;
            gap: 16px;
            color: #666;
            font-size: 14px;
            
            i {
              margin-right: 4px;
            }
          }
        }
      }
      
      .circle-desc {
        padding: 15px 0;
        border-top: 1px solid #f0f0f0;

        .desc-title {
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 12px;
          color: #333;
        }

        .desc-content {
          color: #666;
          font-size: 14px;
          line-height: 1.6;
          margin-bottom: 15px;
        }

        .desc-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          font-size: 14px;

          &:last-child {
            margin-bottom: 0;
          }

          .label {
            color: #999;
            margin-right: 8px;
          }

          .value {
            color: #666;
            &.price {
              color: #ff6b00;
              font-weight: 500;
            }
          }
        }
      }
    }
    
    .hot-posts-card {
      .card-header {
        font-weight: 500;
      }
      
      .hot-post-list {
        .hot-post-item {
          padding: 12px 0;
          border-bottom: 1px solid #eee;
          cursor: pointer;
          
          &:last-child {
            border-bottom: none;
          }
          
          &:hover {
            .post-title {
              color: #409EFF;
            }
          }
          
          .post-title {
            font-size: 14px;
            margin-bottom: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          
          .post-meta {
            display: flex;
            gap: 16px;
            color: #999;
            font-size: 12px;
            
            i {
              margin-right: 4px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .post-detail {
    .post-detail-wrapper {
      flex-direction: column;
    }
    
    .circle-sidebar {
      width: 100%;
    }
  }
}

.post-content {
  .rich-text {
    :deep(.v-note-wrapper) {
      z-index: 1;
      border: none;
      min-height: auto;
      
      .v-note-panel {
        border: none;
      }
      
      .v-note-navigation-wrapper {
        display: none;
      }
      
      .v-show-content {
        background-color: #fff;
        padding: 0;
        
        p {
          margin-bottom: 1em;
        }
        
        img {
          max-width: 100%;
          height: auto;
          margin: 1em 0;
        }
        
        code {
          background-color: #f5f6f7;
          padding: 0.2em 0.4em;
          border-radius: 3px;
        }
        
        pre {
          background-color: #f5f6f7;
          padding: 1em;
          border-radius: 4px;
          overflow-x: auto;
        }
      }
    }
  }
}
</style> 